import { Typography } from "@mui/material";
import { ReactNode } from "react";

import { ListQuote } from "../../types/Quote";
import APModal from "../APModal";
import APButton from "../buttons/APButton";

interface OverwriteQuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  oldestQuote: ListQuote | null;
  children?: ReactNode;
}

const OverwriteQuoteModal = ({
  isOpen,
  onClose,
  onConfirm,
  oldestQuote,
  children,
}: OverwriteQuoteModalProps) => {
  return (
    <APModal
      isOpen={isOpen}
      onClose={onClose}
      closeText="Back"
      confirmButton={
        <APButton variant="contained" text="Yes" onClick={onConfirm} />
      }
    >
      <Typography variant="titleMedium">
        You have reached the maximum number of quotes.
      </Typography>
      {oldestQuote && (
        <Typography variant="titleMedium" mt={2}>
          Overwrite your quote: {oldestQuote.vehicle.year}{" "}
          {oldestQuote.vehicle.make} {oldestQuote.vehicle.model}
        </Typography>
      )}
      {children}
    </APModal>
  );
};

export default OverwriteQuoteModal;
